import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';

import { I100HpServerGame, I100HpGetUrl } from '../../types/interfaces/Slots/100Hp';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<I100HpServerGame[]>): ISlotViewItem[] => {
    const games = data.map((game: I100HpServerGame) => ({
      id: game.id.toString(),
      gameId: game.id.toString(),
      description: game.name,
      gameName: game.name,
      provider: '100hp',
      type: CasinoType.slots,
      routeProvider: '100hp',
      tab: getTab(game.id.toString()),
      imageUrl: game.logoUrl,
    }));
    return games;
  };

  convertGameUrl = ({ data }: I100HpGetUrl) => data.game_url;
}
export default Converter;
